module.exports = __webpack_public_path__ + "static/img/one.f5044c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/14/one.png
// module id = IDh0
// module chunks = 1